import { inject, Pipe, type PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { supportedScannerProfilesDefaults } from '@tig-dpqa-cloud/contract-backend-common';

@Pipe({
  name: 'scanner',
  standalone: true,
})
export class ScannerPipe implements PipeTransform {
  private translateService = inject(TranslateService);

  transform(value: {
    scannerType: string | undefined;
    scannerSerial: string | undefined;
  } | undefined): string {
    if (!value) {
      return '';
    }

    const mappedScannerName = this.getMappedScannerName(value.scannerType);
    // Show the last 4 digits of scanner serial number if available.
    return `${mappedScannerName ?? ''}${mappedScannerName && value.scannerSerial ? '-' : ''}${value.scannerSerial ? value.scannerSerial?.slice(-4) : ''}`.trim();
  }

  getMappedScannerName(scannerType?: string) {
    if (!scannerType) {
      return '';
    }

    const scannerTypeKey = scannerType.toLowerCase();
    if (!Object.hasOwn(supportedScannerProfilesDefaults, scannerTypeKey)) {
      return scannerType;
    }

    const scannerProfile = supportedScannerProfilesDefaults[scannerTypeKey];
    return this.translateService.instant(`SLIDES.SCANNERS.${scannerProfile.name.toUpperCase()}`);
  }
}
